import React from "react";

import { TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Alert, AlertDescription, AlertTitle } from "@/src/components/ui/alert";
import { needsAppsRegeneration } from "@/src/utils/fontFaces";

import type { JSX } from "react";

import type { FontFamily, ProjectFontRoles } from "@/src/api/StylesAPI.types";

interface AppsRegenerationNoticeProps {
  familyList: FontFamily[];
  roles: ProjectFontRoles;
}

function AppsRegenerationNotice({
  familyList,
  roles,
}: AppsRegenerationNoticeProps): JSX.Element | null {
  const { t } = useTranslation("editor-appearance");

  if (!needsAppsRegeneration(familyList, roles)) return null;

  return (
    <Alert variant="warning">
      <TriangleAlert className="size-4" />
      <AlertTitle>{t("appsRegenerationTitle")}</AlertTitle>
      <AlertDescription>{t("appsRegenerationBody")}</AlertDescription>
    </Alert>
  );
}

export default AppsRegenerationNotice;
